<template>
  <div class="wrapper">
    <hooper :settings="hooperSettings" class="hopper w-100">
      <slide class="section header-filter page-header" :style="headerStyle2">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                {{ $t("assurance.slide1.titre") }}
              </h1>
              <h4>
                {{ $t("assurance.slide1.description") }}
              </h4>
              <br />
              <md-button @click="goto" class="md-success md-l">
                {{ $t("assurance.souscrire") }}
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <slide class="section header-filter page-header" :style="headerStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
            >
              <h1 class="title">
                {{ $t("assurance.slide2.titre") }}
              </h1>
              <h4>
                {{ $t("assurance.slide2.description") }}
              </h4>
              <br />
              <md-button @click="goto" class="md-success md-l">
                {{ $t("assurance.souscrire") }}
              </md-button>
            </div>
          </div>
        </div>
      </slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
export default {
  bodyClass: "voyage",
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/hospital.jpg")
    },
    boursier: {
      type: String,
      default: require("@/assets/img/assurance.jpg")
    }
  },
  data() {
    return {
      hooperSettings: {
        infiniteScroll: true,
        centerMode: false,
        autoPlay: true,
        playSpeed: 5000,
        breakpoints: {
          2400: {
            itemsToShow: 1
          },
          1800: {
            itemsToShow: 1
          },
          1500: {
            itemsToShow: 1
          },
          1100: {
            itemsToShow: 1
          },
          1024: {
            itemsToShow: 1
          },
          630: {
            itemsToShow: 1
          },
          504: {
            itemsToShow: 1
          },
          330: {
            itemsToShow: 1
          },
          0: {
            itemsToShow: 1
          }
        }
      }
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },

    headerStyle2() {
      return {
        backgroundImage: `url(${this.boursier})`
      };
    }
  },

  methods: {
    goto() {
      this.$router.push({ path: '/procedure', query: { type: 'assurance' } })
    }
  }
};
</script>

<style lang="scss" scoped>
.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
</style>
